import React, { Component } from 'react';
import { /*Link,*/ withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box/*, Text, Anchor*/ } from 'grommet';
/*import data from '../Data.json';*/
import GestioneRichiesteStep1  from '../Components/GestioneRichiesteStep1';
import GestioneRichiesteStep2  from '../Components/GestioneRichiesteStep2';
import GestioneRichiesteStep3  from '../Components/GestioneRichiesteStep3';
import GestioneRichiesteStep4  from '../Components/GestioneRichiesteStep4';
import { GetEboxListCtrl } from '../Controllers/Ebox/GetEboxListCtrl';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
/*import { logout } from '../Utils/Utility';*/



 class GestioneRichieste extends Component {
    static propTypes = {
		match: PropTypes.object.isRequired,
		location: PropTypes.object.isRequired,
		history: PropTypes.object.isRequired
	}
    constructor(props) {
        super(props)
        this.state = {
            step: 1,
            gestPage: 1,
            data: Array.isArray(this.props.data) ? this.props.data : [],
            showTimeoutModal: false,
            gestore:''
        }
        this.getGestore = this.getGestore.bind(this)
        //this.listaGestori = this.listaGestori.bind(this)
        
    }

    getGestore(el) {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        this.setState({
            gestore: el.eboxCode
        }, function() {
            const self = this;
            GetEboxListCtrl(function (data) {
                self.setState({
                    data: data === '' ? [] : data
                });
            }, function (error) {
                self.setState({
                    status: error
                }, function(){
                    if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                        this.props.history.push({
                            pathname: '/ErrorPage',
                            state: this.state
                        })  
                    } else if (this.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                        // logout();
                        // this.props.history.push({
                        // pathname: '/login'
                        // })
                    } 
                })

            }, this.state, token, ids);
        })
        sessionStorage.setItem("eboxCode", el.eboxCode)
        this.nextStep();
    }

    /*listaGestori(){
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;
        GetEboxListCtrl(function (data) {
            self.setState({
                data: data === '' ? [] : data
            });
        }, function (error) {
            self.setState({
                status: error
            }, function(){
                if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                    this.props.history.push({
                        pathname: '/ErrorPage',
                        state: this.state
                    })  
                } else if (this.state.status === 401) {
                    logout();
                    this.props.history.push({
                    pathname: '/login'
                    })
                } 
            })

        }, this.state, token, ids);
    }*/

    nextStep = () => {
        const { step, gestPage } = this.state
        this.setState({
            step : step + 1,
            gestPage :gestPage + 1 
        })
    }

    prevStep = () => {
        const { step, gestPage } = this.state
        this.setState({
            step : step - 1,
            gestPage: gestPage - 1
        })
    }

    form(step) {
        
    const { gest, data, gestore, showTimeoutModal } = this.state;
    const values = { gest, data, gestore, showTimeoutModal};
    
    switch(step) {
        case 1:
            return <GestioneRichiesteStep1
                    //nextStep={this.nextStep}
                    listaGestori={this.listaGestori}
                    getGestore={this.getGestore}
                    values={values}
                    />
        case 2:
            return <GestioneRichiesteStep2
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    values= {values}
                    />
        case 3:
            return <GestioneRichiesteStep3
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    values={values}
                    />
        case 4:
            return <GestioneRichiesteStep4 
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    setSearch={this.setSearch}
                    setForm={this.setForm}
                    setRadioButton={this.setRadioButton}
                    validForm={this.validForm}
                    /*setRadioButton={this.setRadioButton}*/
                    setCheckbox={this.setCheckbox}
                    showModal={this.showModal}
                    showModalemail={this.showModalemail}
                    /*showModalemail={this.showModalemail}*/
                    closeModal={this.closeModal}
                    values={values}
                    />
        default:
            return null;
    }
}


    render() {
        const {step} = this.state;

        return (
            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Box className='contentbox gestione-richieste-page'>
                    <Box direction='row'>
                        {this.form(step)}
                    </Box>
                </Box>   
            </Box>

        )
    }
}

export default GestioneRichieste = withRouter(GestioneRichieste);
